export default class StatesSaver
{
    state = JSON.parse(localStorage.getItem('siteStates')) || this.initState();
    wasOpened = false;

    constructor()
    {
        document.querySelector('.open-state-button')?.addEventListener('click', () => { this.restoreState('calc'); return false; });
    }

    initState()
    {
        this.state =
        {
            'calc':
            {
                'car': {},
                'services': {},
                'goods': {},
                'step': 0,
                'change':
                {
                    air: true,
                    salon: true
                },
            },
            'record':
            {
                'services': {},
                'address': null,
                'date': null,
                'time': null,
                'name': null,
                'phone': null,
                'comment': null,
                'step': 0
            }
        };
        return this.state;
    }

    saveState()
    {
        localStorage.setItem('siteStates', JSON.stringify(this.state));
    }

    calc =
    {
        'setCarName': (name) =>
        {
            this.state.calc['car']['name'] = name;
            this.saveState();
        },
        'setCarMark': (mark) =>
        {
            this.state.calc['car']['mark'] = mark;
            this.saveState();
        },
        'setCarModel': (model) =>
        {
            this.state.calc['car']['model'] = model;
            this.saveState();
        },
        'setCarModification': (modification) =>
        {
            this.state.calc['car']['modification'] = modification;
            this.saveState();
        },
        'setCarModificationName': (name) =>
        {
            this.state.calc['car']['modificationName'] = name;
            this.saveState();
        },

        'setServiceAirFilter': (change) =>
        {
            this.state.calc['services']['airFilter'] = change;
            this.saveState();
        },
        'setServiceSalonFilter': (change) =>
        {
            this.state.calc['services']['salonFilter'] = change;
            this.saveState();
        },

        'setGoodsOilFilter': (item) =>
        {
            this.state.calc['goods']['oilFilter'] = item;
            this.saveState();
        },
        'setGoodsAirFilter': (item) =>
        {
            this.state.calc['goods']['airFilter'] = item;
            this.saveState();
        },
        'setGoodsSalonFilter': (item) =>
        {
            this.state.calc['goods']['salonFilter'] = item;
            this.saveState();
        },
        'setGoodsOil': (item) =>
        {
            this.state.calc['goods']['oil'] = item;
            this.saveState();
        },

        'setStep': (step) =>
        {
            if (step > 1)
                document.querySelector('.open-state-button').style.display = 'none';
            this.state.calc['step'] = step;
            this.saveState();
        },
        'getStep': () =>
        {
            return this.state.calc.step;
        },

        'setChangeAir': (isChange) =>
        {
            this.state.calc.change.air = isChange;
            this.state.calc.services.air = isChange;
            this.saveState();
        },
        'setChangeSalon': (isChange) =>
        {
            this.state.calc.change.salon = isChange;
            this.state.calc.services.salon = isChange;
            this.saveState();
        }
    };

    record =
    {
        'setServices': (value) =>
        {
            this.state.record['services'] = value;
            this.saveState();
        },
        'setAddress': (value) =>
        {
            this.state.record['address'] = value;
            this.saveState();
        },
        'setDate': (value) =>
        {
            this.state.record['date'] = value;
            this.saveState();
        },
        'setTime': (value) =>
        {
            this.state.record['time'] = value;
            this.saveState();
        },
        'setName': (value) =>
        {
            this.state.record['name'] = value;
            this.saveState();
        },
        'setPhone': (value) =>
        {
            this.state.record['phone'] = value;
            this.saveState();
        },
        'setComment': (value) =>
        {
            this.state.record['comment'] = value;
            this.saveState();
        },

        'setStep': (step) =>
        {
            this.state.record['step'] = step;
            this.saveState();
        }
    };

    checkState(componentToRestore)
    {
        if (this.wasOpened)
            return
        else
            this.wasOpened = true;

        this.state = JSON.parse(localStorage.getItem('siteStates')) || this.initState();

        if (componentToRestore === 'calc')
        {
            if (this.state.calc.step < 2)
                this.state = this.initState();
            else
            {
                let windowText = 'Открыть последний расчёт';
                document.querySelector('.open-state-button').innerHTML = windowText;
                document.querySelector('.open-state-button').style.display = '';
            }
        }
        else if (componentToRestore === 'record')
        {
            if (this.state.record.step < 2)
            {
                this.state = this.initState();
                return;
            }
        }
        else
            throw new Error('Invalid component name. Valid names: calc, record.');
    };

    async restoreState(componentName) {
        if (componentName === 'calc') {
            document.querySelector('.open-state-button').style.display = 'none';
            let step = this.state.calc.step;
            // console.log("Восстановление состояния калькулятора", this.state.calc);

            if (step > 1) {
                this.click(document.querySelector(`[data-mark="${this.state.calc.car.mark}"]`));
            }
            if (step > 2) {
                this.click(document.querySelector(`[data-model="${this.state.calc.car.model}"]`));
            }

            if (step > 3) {
                while (!document.querySelector(`[data-id="${this.state.calc.car.modification}"]`))
                    await this.sleep(100);

                this.click(document.querySelector(`[data-id="${this.state.calc.car.modification}"]`));
                this.click(document.querySelector('.modal-calc__bottom-btn-next'));

                while (!document.querySelector('.modal-calc__table-row'))
                    await this.sleep(100);

                Object.keys(this.state.calc.services).forEach((key) => {
                    const serviceElement = document.querySelector(`[data-rm-service="${key}"]`);
                    const serviceId = Number(key);

                    if (
                        serviceElement &&
                        this.state.calc.services[key] &&
                        !((serviceId === 5 && this.state.calc.change.air === false) || (serviceId === 6 && this.state.calc.change.salon === false))
                    ) {
                        this.click(serviceElement);
                    }
                });

                // console.log("Перед восстановлением чекбоксов:", this.state.calc.change);

                const changeSalonCheckbox = document.querySelector('[data-change-salon]');
                const changeAirCheckbox = document.querySelector('[data-change-air]');

                setTimeout(() => {
                    if (changeSalonCheckbox) {
                        changeSalonCheckbox.checked = this.state.calc.change.salon;
                        // console.log("Чекбокс салонного фильтра установлен:", changeSalonCheckbox.checked);
                    }

                    if (changeAirCheckbox) {
                        changeAirCheckbox.checked = this.state.calc.change.air;
                        // console.log("Чекбокс воздушного фильтра установлен:", changeAirCheckbox.checked);
                    }
                }, 100);
            }
        }
    } 

    click(tag)
    {
        const event = new MouseEvent("click",
            {
                view: window,
                bubbles: true,
                cancelable: true,
            }
        );
        if (tag)
            tag.dispatchEvent(event);
    }

    sleep(time)
    {
        return new Promise((resolve) => setTimeout(resolve, Math.ceil(time)));
    }
};
